import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "REGISTER_VIEW", {
  TITLE: "Register",
  TOKEN_ERROR: "There is an error with your token",
});
